import React from "react";
import { Box, Typography } from "@mui/material";

interface EmptyPlaylistStateProps {
  title?: string;
  description?: string;
}

const EmptyPlaylistState: React.FC<EmptyPlaylistStateProps> = ({
  title = "No Videos Added",
  description = "Click 'ADD VIDEOS' to select videos, or create an empty playlist and add videos later",
}) => (
  <Box
    sx={{
      textAlign: "center",
      padding: 4,
      border: "1px solid #e0e0e0",
      borderRadius: 1,
      backgroundColor: "#fafafa",
    }}
  >
    <Typography variant="body1" color="text.secondary" sx={{ marginBottom: 1 }}>
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {description}
    </Typography>
  </Box>
);

export default EmptyPlaylistState;
